import type { ID } from '@main/schema-utils';
import { slugify } from '@main/utils';

import { AssetFile } from '../schema';

/**
 * Create an asset file from a link
 *
 * @param src - The asset file URL
 * @param override - Provide additional asset file attributes
 * @returns The attribute file
 */
export function createAsset(
  src: string,
  override?: Partial<AssetFile>,
): AssetFile {
  return {
    id: slugify(src) as ID<'assetFile'>,
    key: 'test',
    size: 1000,
    mimetype: 'image/png',
    src,
    ...override,
  };
}
